import React from 'react';
import {useIntl} from 'umi';
import {ProFormDigit} from '@ant-design/pro-form';
import {Form} from "antd";

interface AppointmentSettingsFormProps {
  onFieldBlur?: (name: string | string[], value: any) => void;
  disabled?: boolean;
  /** Overrides `disabled` for the priority field (users_priority_edit grants priority alone). */
  disablePriority?: boolean;
  /** Per-service custom calendars don't support a capacity override. */
  hideCapacity?: boolean;
}

const AppointmentSettingsForm: React.FC<AppointmentSettingsFormProps> = ({disabled = false, disablePriority, hideCapacity = false, onFieldBlur}) => {
  const intl = useIntl();
  const form = Form.useFormInstance();

  return (
      <div>
        {!hideCapacity && <ProFormDigit
          label={intl.formatMessage({
            id: 'pages.users.availability.capacity',
            defaultMessage: 'Appointment Capacity',
          })}
          tooltip={intl.formatMessage({
            id: 'pages.users.availability.capacity.tooltip',
            defaultMessage: 'The number of appointments that can be booked at the same time',
          })}
          name={['availability', 'capacity']}
          disabled={disabled}
          fieldProps={{
            onBlur: () => onFieldBlur?.(['availability', 'capacity'], form.getFieldValue(['availability', 'capacity']))
          }}
        />}
        <ProFormDigit
          label={intl.formatMessage({
            id: 'pages.users.availability.priority',
            defaultMessage: 'Appointment Priority',
          })}
          tooltip={intl.formatMessage({
            id: 'pages.users.availability.priority.tooltip',
            defaultMessage: 'Priority of the agent in the appointment booking process',
          })}
          min={0}
          allowClear
          max={100}
          name={['availability', 'priority']}
          fieldProps={{
            onBlur: () => onFieldBlur?.(['availability', 'priority'], form.getFieldValue(['availability', 'priority']))
          }}
          disabled={disablePriority ?? disabled}
        />
    </div>
  );
};

export default React.memo(AppointmentSettingsForm, () => true);
